import { useTranslation } from 'react-i18next';
import { AppBar, Toolbar, Grid, IconButton } from '@mui/material';
import { styled } from '@mui/system';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import FilterIcon from '@mui/icons-material/FilterList';

interface barProps {
    barheight?: string;
}

const Bar = styled(AppBar)<barProps>(({ theme, barheight }) => ({
    height: barheight,
    zIndex: 1,
    color: theme.palette.filterBar.main,
    backgroundColor: theme.palette.filterBarBackground.main,
    boxShadow: '0px 1px 1px -1px rgb(0 0 0 / 20%), 0px 2px 3px 0px rgb(0 0 0 / 14%), 0px 1px 10px -10px rgb(0 0 0 / 12%)',
    marginBottom: '4px'
}));
Bar.defaultProps = {
    barheight: '60px',
};

const FilterToolbar = styled(Toolbar)((props) => ({
    justifyContent: 'space-between',
    height: '100%',
}));

const FilterBarContainer = styled(Grid)((props) => ({
    alignItems: 'center',
    zIndex: 1,
    width: '100% !important', // override default Grid width
    marginLeft: '0px !important', //remove default Grid left margin
    marginTop: '0px !important', //remove default Grid top margin
}));

interface FilterBarProps {
    children?: React.ReactNode;
    id?: string;
    visible: boolean;
    isValid: boolean;
    barHeight?: string;
    onClear: () => void;
    onSearch?: () => void;
}

const FilterBarTemplate: React.FC<FilterBarProps> = props => {
    const { id, visible=false, isValid=true, barHeight='60px' } = props;
    const { t: translate } = useTranslation();
    const isManualSearchVisible = (props.onSearch !== undefined);

    const onClearAllClick = () => {
        props.onClear();
    }

    const closeButton = (
        <IconButton
            aria-label={`${translate("filters.clear")}`}
            id="clear-button"
            size="large"
            onClick={onClearAllClick}
            title={`${translate("filters.clear")}`}
        >
            <CloseIcon />
        </IconButton >
    );

    const onSearchClick = () => {
        if (props.onSearch) {
            props.onSearch();
        }
    }

    const searchButton = (
        <IconButton
            aria-label={`${translate("filters.search")}`}
            id="search-button"
            size="large"
            color="primary"
            disabled={!isValid}
            onClick={onSearchClick}
            title={`${translate("filters.search")}`}
        >
            <SearchIcon />
        </IconButton >
    );
   
    let visibilityState = visible ? "flex" : "none";

    return (
        <FilterBarContainer container spacing={2} id={id} sx={{display: visibilityState}}>
            <Bar position="static" barheight={barHeight}>
                <FilterToolbar variant='dense'>
                    <FilterIcon fontSize="large" />
                    <Grid container item gap={'8px'} justifyContent={'flex-end'} alignItems='center' >
                        {props.children}
                    </Grid>
                    {isManualSearchVisible && searchButton}
                    {closeButton}
                </FilterToolbar>
            </Bar>
        </FilterBarContainer>
    );
};

export default FilterBarTemplate;